// extracted by mini-css-extract-plugin
export var cartContainer = "_ih-4";
export var gray = "_ih-1";
export var itemContainer = "_ih-2";
export var itemDetails = "_ih-3";
export var strong = "_ih-0";